module.exports = __webpack_public_path__ + "img/edge-internet-explorer.png";